import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public reciveControlSystemsNameSubject: BehaviorSubject<any>;
  public reciveControlSystemsNameObservable: Observable<any>;
  public reciveControlSystemsIdSubject: BehaviorSubject<any>;
  public reciveControlSystemsIdObservable: Observable<any>;
  constructor() {
    this.reciveControlSystemsNameSubject = new BehaviorSubject<any>(null);
    this.reciveControlSystemsNameObservable = this.reciveControlSystemsNameSubject.asObservable();

    this.reciveControlSystemsNameObservable.subscribe(data => {

    });


    this.reciveControlSystemsIdSubject = new BehaviorSubject<any>(null);
    this.reciveControlSystemsIdObservable = this.reciveControlSystemsIdSubject.asObservable();

    this.reciveControlSystemsIdObservable.subscribe(data => {

    });
  }
}
